import React from 'react'
import Navbar from '../component/Navbar'
import Hero from '../component/Hero'
import Night from "../assets/night.jpg"
import Footer from '../component/Footer'
import Trip from "../component/Trip"
const Service = () => {
  return (
    <div>
      <Navbar />
      <Hero 
        cName = "hero-mid" 
        heroImg={Night}
        title="Service"
        btnClass="hide"
        />
        <Trip />
         <Footer />
    </div>
  )
}

export default Service
